import { useTranslation } from 'react-i18next'
import { isApiError } from '@/lib/http/errors'

/**
 * Turns any thrown value into text a citizen can act on.
 *
 * The catalogue is the default, because the DHA API documents no error schema and
 * most of what it returns is written for an integrator, not for the person trying
 * to replace their ID card. `error.reason` is the exception: the gateway sometimes
 * states the actual cause in plain words — "Application is in the incorrect state
 * for the requested operation" — and that beats our generic line for the status
 * code every time. `extractReason` is what decides a string qualifies.
 */
export function useApiErrorMessage() {
  const { t } = useTranslation('errors')

  return function messageFor(error: unknown): string | undefined {
    if (!error) return undefined

    if (isApiError(error)) {
      const message = error.reason ?? t(error.messageKey.replace('errors:', '') as 'api.unknown')
      return error.correlationId
        ? `${message} ${t('reference', { correlationId: error.correlationId.slice(0, 8) })}`
        : message
    }

    return t('api.unknown')
  }
}
